import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import paths from '../routes/paths';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const hasSessionToken = Boolean(sessionStorage.getItem("authToken"));
  const isSessionAuthenticated = isAuthenticated && hasSessionToken;

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (isSessionAuthenticated) {
    // Redirect to dashboard if already authenticated
    const from = location.state?.from?.pathname || paths.root;
    return <Navigate to={from} replace />;
  }

  return children;
};

export default PublicRoute;
